import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate } from "react-router-dom";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import {
  checkMobile,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import FPVerifyOTP from "./FPVerifyOTP";
import ResetPassword from "./ResetPassword";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { IS_LOGGED_IN_USER } from "../../../../assests/extention/commonfunction";
import { getProfile } from "../../../../redux/profile/action";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const path = "Assets/scss/FirstTimeUsers.module.scss";

const validationSchema = Yup.object().shape({
  email_id: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const ForgetPassword = () => {
  const [lan, setLan] = useState(localStorage.getItem("laung") ?? "en");
  const [nextPage, setnextPage] = useState(true);
  const [nextPage1, setnextPage1] = useState(true);
  const [valuess, setValuess] = useState(null);
  const navigate = useNavigate();
  const profiledata = useSelector(({ profile: { profiledata } }) => profiledata,);
  const dispatch = useDispatch();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (IS_LOGGED_IN_USER) {
      dispatch(getProfile());
    }
  }, [IS_LOGGED_IN_USER]);

  const initialValues = {
    email_id: IS_LOGGED_IN_USER ? profiledata?.email_id : "",
  };

  const handleSubmit = (values) => {
    const state = values;
    checkMobile(values)
      .then((res) => {
        if (res.data.status) {
          sendOTP(values)
            .then((res) => {
              if (res.data.status) {
                urtoast(`OTP sent successfully.`, 1);
                // navigate(`/${lan}/forgetpasswordotpverify`, { state });
                setValuess(values);
                setnextPage(false);
              } else {
                urtoast(`${res?.data?.response?.message}`, 2);
              }
            })
            .catch((e) => {
              urtoast(`${e.message} || "Error sending OTP"`, 2);
            });
        } else {
          urtoast(`${res?.data?.response?.message}`, 2);
        }
      })
      .catch((e) => {
        urtoast(`${e.message} || "Error checking mobile number"`, 2);
      });
  };

  return (
    <>
      {nextPage && nextPage1 ? (
        <div className="mx-auto register ">
          <img
            className="mail-img mb-2"
            src={`${CloudStorage.cloudurl}/Assets/Images/common/forgetpassword.svg`}
            alt=""
          />
          <h1 className="heading">Forgot password?</h1>
          <p style={{ display: "flex", justifyContent: "center" }}>
            Please enter your email address linked with your account.
          </p>
          <br></br>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnChange={false}
            enableReinitialize={true}  // ✅ reinitialize when profiledata updates
          >
            {({ errors, values, touched }) => (
              <Form>
                { }

                <div className="col-md-8 mx-auto form-sec mobile-otp">
                  <div className="form-group">
                    <label htmlFor="email_id">Registered Email ID <AsteriskLabel /></label>
                    <Field
                      type="email"
                      name="email_id"
                      id="email_id"
                      className={`form-control ${touched.email_id && errors.email_id ? "is-invalid" : ""}`}
                      placeholder="Enter your registered email ID"
                      disabled={IS_LOGGED_IN_USER}
                    />
                    <ErrorMessage
                      name="email_id"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="last-form">
                    <button type="submit" className="btn create-account">
                      Continue
                    </button>
                    <a
                      onClick={() => {
                        // navigate(`/${lan}/forgetpasswordwithmobileno`);
                        navigate(`/${lan}/forgetpasswordwithmobileno/change`)
                      }
                      }
                      className="login-password"
                    >
                      Use mobile number
                    </a>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : nextPage == false && nextPage1 == true ? (
        <FPVerifyOTP
          setnextPage={setnextPage}
          setnextPage1={setnextPage1}
          valuess={valuess}
        />
      ) : (
        <ResetPassword valuess={valuess} />
      )}
    </>
  );
};

export default ForgetPassword;
